import MaquinaAPI from '@/api/produccion/maquina';

export default {
  namespaced: true,
  actions: {
    fetch_maquinas() {
      return MaquinaAPI.index();
    },
    create_maquina(_, data) {
      return MaquinaAPI.create(data);
    },
    update_maquina(_, { id, data }) {
      return MaquinaAPI.update(id, data);
    },
    delete_maquina(_, id) {
      return MaquinaAPI.destroy(id);
    },
  },
};
